import config from 'config';
import debouncePromise from 'debounce-promise';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AsyncSelect from 'react-select-v3/async';
import * as http from 'utils/http';

import { StyledFilter, reactSelectStyles } from './styled';

class MunicipalityFilter extends Component {
  static filterName = 'MunicipalityFilter';

  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
    intl: PropTypes.any,
    stylingProps: PropTypes.object,
  };

  static defaultProps = {
    stylingProps: {},
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.getCities = debouncePromise(this.getCities.bind(this), 500, { leading: true });
  }

  async getCities(input) {
    if (!input || input.length < 3) {
      return Promise.resolve([{}]);
    }

    const cities = await http.get(
      `${config.API_URL}mercury/addresses/?search=${input}&page_size=0`
    );

    const options = (cities || []).map((cityObject) => {
      return { label: cityObject.city, value: cityObject.city };
    });

    return options;
  }

  handleChange(value) {
    const { onChange } = this.props;

    onChange(value);
  }

  render() {
    const { intl, value, stylingProps } = this.props;

    const t = intl.messages.components.ShipmentFilters;

    return (
      <StyledFilter {...stylingProps}>
        <AsyncSelect
          placeholder={t.municipality_filter_placeholder}
          isClearable
          value={value}
          onChange={this.handleChange}
          loadOptions={this.getCities}
          styles={reactSelectStyles}
        />
      </StyledFilter>
    );
  }
}

export default MunicipalityFilter;
